/**
 * This is a collection of behaviours for items which should be called in a View update function.
 * @module views/Behaviours
 */
import * as THREE from 'three';

/**
 * itemFaceCamera sets desiredRotation of an item to look at the camera.
 */
export function itemFaceCamera() {
    const elem = this.element;
    elem.lookAt(this.cam.cameraWrap.position);
    this.desiredRotation.copy(elem.quaternion);
}

/**
 * itemFaceCameraY makes the item look towards the camera but sets X and Z rotation to 0.
 */
export function itemFaceCameraY() {
    const elem = this.element;
    elem.lookAt(this.cam.cameraWrap.position);
    elem.rotation.x = 0;
    elem.rotation.z = 0;
    this.desiredRotation.copy(elem.quaternion);
}

/**
 * itemFaceCenter aligns the item towards the center along the Y axis.
 */
export function itemFaceCenter() {
    const elem = this.element;
    elem.lookAt(new THREE.Vector3(0,this.currentPosition.y,0));
    elem.rotateY(Math.PI);
    this.desiredRotation.copy(elem.quaternion);
}

/**
 * itemFaceWheel aligns the item towards the center along the X axis.
 */
export function itemFaceWheel() {
    const elem = this.element;
    elem.lookAt(new THREE.Vector3(this.currentPosition.x, 0, 0));
    this.desiredRotation.copy(elem.quaternion);
}

/**
 * itemFaceZ aligns the item towards positive Z.
 */
export function itemFaceZ() {
    const elem = this.element;
    elem.lookAt(new THREE.Vector3(this.currentPosition.x, this.currentPosition.y, this.currentPosition.z+1));
    this.desiredRotation.copy(elem.quaternion);
}

/**
 * itemCopyCamera copies the camera rotation instantly, makes the item align perfectly flat.
 */
export function itemCopyCamera() {
    this.desiredRotation.copy(this.cam.cameraWrap.quaternion);
    this.currentRotation.copy(this.cam.cameraWrap.quaternion);
}